import { render, staticRenderFns } from "./UserAdminAccess.vue?vue&type=template&id=6859c0f5&scoped=true"
import script from "./UserAdminAccess.vue?vue&type=script&lang=js"
export * from "./UserAdminAccess.vue?vue&type=script&lang=js"
import style0 from "./UserAdminAccess.vue?vue&type=style&index=0&id=6859c0f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6859c0f5",
  null
  
)

export default component.exports